(function () {
  try {
    var variation_name = "product-card-direct-pdp-redirect-mobile";

    // Run only on mobile
    if (window.innerWidth > 767) return;

    function waitForElement(trigger, delayInterval, delayTimeout) {
      delayInterval = delayInterval || 100;
      delayTimeout = delayTimeout || 30000;
      var interval = setInterval(function () {
        var host = document.querySelector("#fast-simon-serp-app");
        if (!host || !host.shadowRoot) return;
        var grid = host.shadowRoot.querySelector("#products-grid");
        if (grid && grid.querySelector(".product-card")) {
          clearInterval(interval);
          trigger(host.shadowRoot);
        }
      }, delayInterval);
      // Failsafe: stop polling after delayTimeout even if the grid never appears.
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    // matches()/closest() polyfills for older WebKit
    if (window.Element && !Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        Element.prototype.msMatchesSelector;
    }
    if (window.Element && !Element.prototype.closest) {
      Element.prototype.closest = function (selector) {
        var el = this;
        while (el && el.nodeType === 1) {
          if (el.matches(selector)) return el;
          el = el.parentElement || el.parentNode;
        }
        return null;
      };
    }

    // Real form/interactive controls are excluded. Title and main image are
    // already <a> links, but we still want our own handler to catch taps on
    // them, so "a[href]" is intentionally NOT in this list.
    var EXCLUDE_SELECTOR =
      "button, input, select, textarea, label, .fs-add-to-cart, .quantity, [data-add-to-cart]";
    var TAP_MOVE_THRESHOLD = 10; // px of movement beyond which we treat it as a swipe/scroll, not a tap

    function getProductUrl(card) {
      var link =
        card.querySelector("a.title-container[href]") ||
        card.querySelector("a.fs-product-main-image-wrapper[href]") ||
        card.querySelector('a[href*="/products/"]');
      return link ? link.href : null;
    }

    function findCard(el, root) {
      while (el && el !== root) {
        if (el.matches && el.matches(".product-card")) return el;
        el = el.parentElement || el.parentNode;
      }
      return null;
    }

    function init(shadowRoot) {
      document.body.classList.add(variation_name);

      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartTarget = null;
      var navigating = false; // guards against touchend + click both firing navigation

      function tryNavigate(target, e) {
        if (navigating || !target) return;
        if (target.closest && target.closest(EXCLUDE_SELECTOR)) return;

        var card = findCard(target, shadowRoot);
        if (!card) return;

        var url = getProductUrl(card);
        if (!url) return;

        navigating = true;
        if (e.cancelable) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
        window.location.href = url;
        setTimeout(function () {
          navigating = false;
        }, 500);
      }

      // Primary path on touch devices: touchend fires reliably even when iOS
      // decides not to synthesize a "click" (e.g. if any inner swipe/carousel
      // handler calls preventDefault on touchmove). We only treat it as a tap
      // if the finger didn't move more than TAP_MOVE_THRESHOLD px.
      shadowRoot.addEventListener(
        "touchstart",
        function (e) {
          var t = e.touches[0];
          touchStartX = t.clientX;
          touchStartY = t.clientY;
          touchStartTarget = e.target;
        },
        true
      );

      shadowRoot.addEventListener(
        "touchend",
        function (e) {
          if (!touchStartTarget) return;
          var t = e.changedTouches[0];
          var dx = Math.abs(t.clientX - touchStartX);
          var dy = Math.abs(t.clientY - touchStartY);
          if (dx > TAP_MOVE_THRESHOLD || dy > TAP_MOVE_THRESHOLD) return; // was a swipe/scroll
          tryNavigate(touchStartTarget, e);
        },
        true
      );

      // Fallback for non-touch input (mouse/trackpad, or if touch events
      // aren't available for some reason).
      shadowRoot.addEventListener(
        "click",
        function (e) {
          tryNavigate(e.target, e);
        },
        true
      );
    }

    waitForElement(init);
  } catch (e) {
    // Fail silently in production — never let this script break the page.
  }
})();